<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('addFilesModalTitle') }}</div>
    </template>
    <Spinner v-show="dataIsSending"/>
    <div v-show="!dataIsSending" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-0">
<!--        <FileUploader :item="{ id: orderId }"-->
        <FileUploader :item="{ id: null }"
                      @select="onFileSelect"
                      @clear="onFilesClear"
                      @remove="onFileRemove"
                      ref="fileUploader"
                      field="order_files"
                      :multiple="true"
                      :allowNonImages="true"
                      :imagesOnly="false"
                      :itemWidth="130"
                      :itemHeight="130"
                      :maxFiles="10"
                      :maxFilesPerUpload="10"
                      :existingFilesCount="orderFilesLength"
                      :maxSizeMb="10"
                      :maxWidth="1600"
                      :maxHeight="1600"
                      :jpegQuality="0.82"
                      resizeMode="contain"/>
      </div>
    </div>
    <template #footer>
      <Button :label="$t('Cancel')" icon="pi pi-times" class="p-button-text" @click="close"/>
      <Button :disabled="!attachments?.length || dataIsSending"
              :loading="dataIsSending"
              :label="$t('Save')"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveFiles"/>
    </template>
  </Modal>
</template>
<script>
import httpClient from '@/services/http.services'
import formatMixins from "@/mixins/formatMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import FileUploader from "@/components/FileUploader";

export default {
  mixins: [ formatMixins, showErrorsMixins ],
  components: {
    FileUploader,
    // ModifiedFileUpload
  },
  emits: ['close', 'update-item'],
  name: 'OrderFilesModal',
  props: {
    orderId: [Number, null],
    orderFilesLength: [Number, null],
    visible: Boolean,
  },
  data() {
    return {
      // maxFileSize: 6500000,
      dataIsSending: false,
      submitted: false,
      attachments: [],
      // file: null,
      settings
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.submitted = false
        this.attachFiles = true
        this.clearAttachments()
      }
    },
  },
  methods: {
    clearAttachments() {
      this.attachments = []
      this.$refs.fileUploader?.clearAttachments()
    },
    onFileSelect(data) {
      this.attachments = data.files || []
    },
    onFilesClear() {
      this.attachments = []
    },
    onFileRemove(data) {
      this.attachments = data?.files || []
    },
    async saveFiles() {
      this.submitted = true
      this.dataIsSending = true

      let formData = new FormData();
      formData.append('orderId', this.orderId)

      const attachmentsLength = this.attachments?.length
      if (attachmentsLength) {
        for (let i = 0; i < attachmentsLength; i++)
          formData.append(i, this.attachments[i])
      }

      try {
        const { status, data } = await httpClient.post(`order-file/upload-files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        if (status === 201 && data?.success) {
          this.$emit('update-item', this.orderId, true) //True === sent socket, for Order page
          this.$toast.add({severity:'success', detail: this.$t('Data updated'), life: settings.toastLife});
          this.clearAttachments()
          this.close()
        } else if (data?.error) {
          this.$toast.add({severity:'error', summary: data.error.summary, detail: data.error.detail, life: settings.toastLife});
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
      }
    },
    close() {
      this.$emit('close')
      this.submitted = false
    },
  },
  computed: {
    computedWindowSize() {
      if (this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '630px', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '630px', marginTop: '25px'}
      } else {
        return {position: 'absolute', top: 0, width: '750px', marginTop: '50px'}
      }
    },
  },
}
</script>
<style scoped lang="scss">
.removed-attachment {
  text-decoration: line-through;
}
</style>